import * as React from 'react';
import styled from '@emotion/styled';
import { MDXProvider } from '@mdx-js/react';

import ThemeProvider from './theme/themeProvider';
import mdxComponents from './mdxComponents';
import Sidebar from './sidebar';
import RightSidebar from './rightSidebar';
import config from '../../config.js';

/**
 * Layout Styles - Updated to match Figma responsive breakpoints
 * Breakpoints:
 * - ≤576px: Extra Small/Mobile
 * - 577-768px: Small/Mobile Landscape
 * - 769-992px: Medium/Tablet
 * - 993-1440px: Large/Desktop
 * - 1441-1920px: Extra Large
 * - >1920px: Ultra Wide
 */

const Wrapper = styled('div')`
  display: flex;
  align-items: flex-start;
  background: var(--color-bg-container);
  min-height: calc(100vh - var(--header-height));
  width: 100vw;

  @media (max-width: 992px) {
    min-height: calc(100vh - var(--header-height-mobile));
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

const Content = styled('main')`
  display: flex;
  flex-grow: 1;
  padding: 0;
  padding-top: var(--gap-4x, 20px);
  background: var(--color-bg-container);
  max-width: 100vw;
  overflow: hidden;

  @media (min-width: 992px) {
    padding-top: 3rem;
    padding-left: var(--gap-6x, 30px);
    padding-right: var(--gap-6x, 30px);
  }
`;

const MaxWidth = styled('div')`
  width: 100%;
  max-width: 800px;
  padding: 0 var(--gap-3x, 15px);
  margin-left: 0;
  margin-right: 0;

  @media (min-width: 768px) and (max-width: 992px) {
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1920px) {
    margin-left: auto;
    margin-right: auto;
  }
`;

const LeftSideBarWidth = styled('div')`
  width: 340px;
  flex-shrink: 0;
  background: var(--color-bg);
  border-right: 1px solid var(--color-border-secondary);
  position: sticky;
  top: var(--header-height);
  height: calc(100vh - var(--header-height));
  overflow-y: auto;

  @media (max-width: 992px) {
    display: none;
  }
`;

const RightSideBarWidth = styled('div')`
  width: 300px;
  flex-shrink: 0;
  position: sticky;
  top: var(--header-height);
  height: calc(100vh - var(--header-height));
  overflow-y: auto;

  @media (max-width: 1440px) {
    display: none;
  }
`;

const Layout = ({ children, location }) => (
  <ThemeProvider location={location}>
    <MDXProvider components={mdxComponents}>
      <Wrapper>
        <LeftSideBarWidth className={'hiddenMobile'}>
          <Sidebar location={location} />
        </LeftSideBarWidth>
        {config.sidebar.title ? (
          <div
            className={'sidebarTitle sideBarShow'}
            dangerouslySetInnerHTML={{ __html: config.sidebar.title }}
          />
        ) : null}
        <Content>
          <MaxWidth>{children}</MaxWidth>
        </Content>
        <RightSideBarWidth className={'hiddenMobile'}>
          <RightSidebar location={location} />
        </RightSideBarWidth>
      </Wrapper>
    </MDXProvider>
  </ThemeProvider>
);

export default Layout;
